<script setup lang="ts">

import type { IProductQuestion } from '~/interfaces/product/IProductPageData';

const props = defineProps<{
  productQuestionsCollection: IProductQuestion[]
}>()

const {
  productQuestionsCollection,
} = toRefs(props)
</script>

<template>
  <div>
    <div class="size--body weight--intermedium pr">
      <span id="questions" class="anchor__target"/>
      {{ $t('www.product.question-answer.title', {'length': productQuestionsCollection.length}) }}
    </div>
    <section class="mt-1">
      <div
          v-for="(questionAnswer, index) in productQuestionsCollection"
          :key="index"
          class="mt-2 mb-2">
        <div class="df">
          <div class="w90px bold-text">{{ $t('www.product.question') }}</div>
          <div class="c-blue-light" v-html="questionAnswer.question"/>
        </div>
        <div class="df mb-2 mt-2">
          <div class="w90px bold-text">{{ $t('www.product.answer') }}</div>
          <div v-html="questionAnswer.answer"/>
        </div>
        <div class="separator--pdp"/>
      </div>
    </section>
  </div>
</template>
